import { PRODUCT_IMAGES } from "../../utils/imagesMap"

const comparisonColumns = [
  `Recommended Age Range`,
  `If you are Experiencing`,
  `Differences`,
]

const suffix = `<br /><span style='color:#005752; padding-top: 8px;' class='block'>Free shipping. Pause or cancel anytime.</span>`

export const data = {
  seo: {
    title: "Save $50 On Your First Order",
    description:
      "Nutrafol is physician-formulated to improve hair growth with visible thickness by multi-targeting root causes of thinning using clinically effective, natural, drug-free ingredients that support whole-body health. Trusted by over 3,500 physicians.",
  },
  comparisonColumnsArr: [
    {
      text: `For who`,
    },
    {
      text: `Optimized for`,
    },
    {
      text: `Clinically effective`,
    },
  ],
  products: {
    Women: {
      heading: "Women",
      img: PRODUCT_IMAGES.WOM1.label4,
      imgv2: PRODUCT_IMAGES.WOM1.label3,
      dropdownImg: PRODUCT_IMAGES.WOM1.label3 + "&w=182",
      label: PRODUCT_IMAGES.WOM1.label0,
      name: "Women",
      subtext: "For women 18-44.",
      options: [
        {
          title: "3-Month Delivery",
          savings: "$50 Off*",
          price_interval: "qtr",
          sku: "WOM3PROMO-S01",
          discount: 50,
          description:
            "A 3-month supply with refills delivered every 3 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "6-Month Delivery",
          savings: "$106 Off",
          sku: "WOM6-S01",
          discount: 106,
          description:
            "A 6-month supply with refills delivered every 6 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "Monthly Delivery",
          sku: "WOM1-S01",
          description:
            "A 1-month supply each month + free naturopathic doctor consults." +
            suffix,
        },
      ],
      comparison: {
        comparisonColumns,
        name: "Women's",
        comparisonItemsArray: ["Women 18-44", 0, 1],
        comparisonItems: [
          "18-35",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
        ],
      },
    },
    Vegan: {
      heading: "Vegan",
      img: PRODUCT_IMAGES.VEG1.label4,
      imgv2: PRODUCT_IMAGES.VEG1.label3,
      dropdownImg: PRODUCT_IMAGES.VEG1.label3 + "&w=182",
      label: PRODUCT_IMAGES.VEG1.label0,
      name: "Women's Vegan",
      subtext: "For women 18-44 with plant-based lifestyles.",
      className: "vegan",
      options: [
        {
          title: "3-Month Delivery",
          savings: "$50 Off*",
          price_interval: "qtr",
          sku: "VEG3PROMO-S01",
          discount: 50,
          description:
            "A 3-month supply with refills delivered every 3 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "6-Month Delivery",
          savings: "$106 Off",
          sku: "VEG6-S01",
          discount: 106,
          description:
            "A 6-month supply with refills delivered every 6 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "Monthly Delivery",
          sku: "VEG1-S01",
          description:
            "A 1-month supply each month + free naturopathic doctor consults." +
            suffix,
        },
      ],
      comparison: {
        comparisonColumns,
        name: "Women's Vegan",
        comparisonItemsArray: ["Women 18-44", "Plant-based lifestyle", 1],
        comparisonItems: [
          "18-35",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
        ],
      },
    },
    Balance: {
      heading: "Women's Balance",
      img: PRODUCT_IMAGES.BAL1.label4,
      imgv2: PRODUCT_IMAGES.BAL1.label3,
      dropdownImg: PRODUCT_IMAGES.BAL1.label3 + "&w=182",
      label: PRODUCT_IMAGES.BAL1.label0,
      name: "Women's Balance",
      subtext: "For women 45+.",
      options: [
        {
          title: "3-Month Delivery",
          savings: "$50 Off*",
          price_interval: "qtr",
          sku: "BAL3PROMO-S01",
          discount: 50,
          description:
            "A 3-month supply with refills delivered every 3 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "6-Month Delivery",
          savings: "$106 Off",
          sku: "BAL6-S01",
          discount: 106,
          description:
            "A 6-month supply with refills delivered every 6 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "Monthly Delivery",
          sku: "BAL1-S01",
          description:
            "A 1-month supply each month + free naturopathic doctor consults." +
            suffix,
        },
      ],
      comparison: {
        comparisonColumns,
        name: "Women's Balance",
        comparisonItemsArray: [
          "Women 45+",
          "Hormonal changes, such as menopause",
          1,
        ],
        comparisonItems: [
          "35-99",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
        ],
      },
    },
    Postpartum: {
      heading: "Postpartum",
      img: PRODUCT_IMAGES.POS1.label4,
      imgv2: PRODUCT_IMAGES.POS1.label3,
      dropdownImg: PRODUCT_IMAGES.POS1.label3 + "&w=182",
      label: PRODUCT_IMAGES.POS1.label0,
      name: "Postpartum",
      subtext: "For women first year post-childbirth.",
      options: [
        {
          title: "3-Month Delivery",
          savings: "$50 Off*",
          price_interval: "qtr",
          sku: "POS3PROMO-S01",
          discount: 50,
          description:
            "A 3-month supply with refills delivered every 3 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "6-Month Delivery",
          savings: "$106 Off",
          sku: "POS6-S01",
          discount: 106,
          description:
            "A 6-month supply with refills delivered every 6 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "Monthly Delivery",
          sku: "POS1-S01",
          description:
            "A 1-month supply each month + free naturopathic doctor consults." +
            suffix,
        },
      ],
      comparison: {
        comparisonColumns,
        name: "Women's Postpartum",
        comparisonItemsArray: [
          "Women in the first year post-childbirth",
          "Postpartum recovery",
          1,
        ],
        comparisonItems: [
          "18-45",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
          "Lörem ipsum didade savasamma ell. Fadina gigana. Fadina gigana. ",
        ],
      },
    },
    Men: {
      img: PRODUCT_IMAGES.MENPRO1.label3,
      imgv2: PRODUCT_IMAGES.MENPRO1.label3,
      dropdownImg: PRODUCT_IMAGES.MENPRO1.label3 + "&w=182",
      label: PRODUCT_IMAGES.MENPRO1.label0,
      name: "Men",
      subtext: "For men 18+.",
      options: [
        {
          title: "3-Month Delivery",
          savings: "$50 Off*",
          price_interval: "qtr",
          sku: "MEN3PROMO-S01",
          discount: 50,
          description:
            "A 3-month supply with refills delivered every 3 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "6-Month Delivery",
          savings: "$106 Off",
          sku: "MENPRO6-S01",
          discount: 106,
          description:
            "A 6-month supply with refills delivered every 6 months + free naturopathic doctor consults." +
            suffix,
        },
        {
          title: "Monthly Delivery",
          sku: "MENPRO1-S01",
          description:
            "A 1-month supply each month + free naturopathic doctor consults." +
            suffix,
        },
      ],
      comparison: {
        comparisonColumns,
        name: "Men",
        comparisonItemsArray: ["Men experiencing hair thinning", "", 1],
        comparisonItems: [""],
      },
    },
  },
  atcArea: {
    purchase_source: "&purchase_source=influencer_lp",
    heading: `Nutrafol Hair Growth Nutraceuticals`,
    dosage1: `4 PILLS A DAY`,
    dosage2: `ONE BOTTLE PER MONTH`,
    subheading: `Physician-formulated to promote hair growth with visible thickness and less shedding by multi-targeting root causes of thinning using natural ingredients. Designed to support whole-body health while meeting the bio-specific needs of women and men throughout all life stages.<sup>1-4</sup>`,
    subheadingVegan: `Physician-formulated to promote hair growth with visible thickness and less shedding by multi-targeting key root causes of thinning using drug-free ingredients. Designed to support whole-body health while meeting the bio-specific needs of women and men throughout all life stages.<sup>1-4, 14</sup>`,
  },
  kitArea: {
    id: "upsell",
    sku: "HBALANCEKIT-N01",
    text_description:
      "On-the-go sizes of physician-formulated hair care essentials to support hair health.",
    img: "https://images.ctfassets.net/0rbfqd9c4jdo/5wMGA4wygfMctBUJgr3Qs0/93c4dfb09493308ba1589e60731d5d6c/ScalpSupportTravelTrio_Catalog_Silhouette_1.png?fl=progressive",
    title: "Scalp Travel Set",
  },
  dropdownOptions: [
    {
      value: "Postpartum",
      label: "Postpartum",
      idx: 0,
    },
    {
      value: "Women",
      label: "Women",
      idx: 1,
    },
    {
      value: "Balance",
      label: "Balance",
      idx: 2,
    },
    {
      value: "Men",
      label: "Men",
      idx: 3,
    },
  ],
  stats: {
    initialMobileSlide: 1,
    tiles: [
      [
        {
          stat: "83%",
          width: "60%",
          ref: "15",
          title: "of men saw better hair quality",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/3VToXYhoe94DaEoOIcnVmF/0707386d28f4492eb7c063de4c2e1946/stats-01.png?fl=progressive",
        },
        {
          stat: "100%",
          width: "58%",
          ref: "17",
          title:
            "of women showed visible improvement in hair growth during peri- or postmenopause",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/vGlfnXlgL6K4zuRhoxRcE/5f9eab63107cc3c290547db22547b347/stats-02.png?fl=progressive",
        },
      ],
      [
        {
          stat: "86%",
          ref: "17",
          width: "60%",
          title: "of women saw thicker hair during peri- or postmenopause",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/51Zqzwro31EH8tdTLqUwsV/46e2ac28cba8c4566e6c98d7264d54c7/stats-03.png?fl=progressive",
        },
        {
          stat: "75%",
          ref: "15",
          width: "60%",
          title: "saw visibly less shedding",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/3kDLNgYdjJYeCVHH8m6FcV/309753c36c51aea10bf35e0f6b1bc398/stats-04.png?fl=progressive",
        },
      ],
      [
        {
          stat: "84%",
          ref: "16",
          width: "50%",
          title: "saw thicker, stronger, softer hair growth",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/4wBfJoQdDT3LxO671TkuJ6/d81b7071e118076e6be39f9283f69358/stats-05.png?fl=progressive",
        },
        {
          stat: "72%",
          width: "50%",
          ref: "15",
          title: "of men saw more scalp coverage",
          icon: "https://images.ctfassets.net/0rbfqd9c4jdo/48Xv7jdy3PffqO2bUpxXcy/1c1389b5792c3ba1761d5cf858f70591/stats-06.png?fl=progressive",
        },
      ],
    ],
    heading: `Our formula puts <b>innovation</b> to the test.`,
    subheading:
      "Our randomized, double-blind, placebo-controlled clinical trials and studies  are published in prestigious medical journals.",
    references:
      "*New customers only. Limit one per customer. Not combinable with other offers. Limited time.<br/>1. Auddy B HJ. JANA. 2008. 2. Beoy, L. Tropical Life Sciences Research. 2010.  3. Wlodarczyk, M. Int J of Biological Macromolecules. 2017. 4. Strand, P. J of Cell Science. 2011. 5. Le Floc’h, C. JCD. 2014. 6. Kang, J. IJMS. 2018. 7. Innis, SM. Placenta. 2005. 8. Pandely, A. Bio Med & Pharm. 2018. 9. Shatavari LactMed, 2021. 10. Tenore, G. J Med Food. 2016. 11. Zlotta, A.R. Eur Urol, 2005. 12. Pytel, Y.A. Advanced Therapeutics, 2002. 13. Meissner, H.O. IJBS. 2005. 14. Gonzales, C. Andrologia. 2012. 15. Marshall T, et al. ADA, 2020. 16. Ablon, G. J Drugs Dermatology. 17. Berkowitz S, et al. ASDS, 2020.",
  },
  clinicalProof: {
    pt: ["0px", "16px", "36px", "64px"],
    pb: ["16px", "16px", "36px", "64px"],
    heading: "Clinically tested for real results.",
    image:
      "https://images.ctfassets.net/0rbfqd9c4jdo/5VpsclpVv7xvk4SKjQnFFL/52756a6baeeff220c8d9c0b4c1f8a4ad/proof-landscape.jpg?fl=progressive",
    imagealt:
      "https://images.ctfassets.net/0rbfqd9c4jdo/17dCmbLIuOyPBjmvzxGbJp/6b61a39fcc08b607e52b95f8cad01e0a/proof-portrait.jpg?fl=progressive",
    stats: [
      {
        isVegan: true,
        number: "100%",
        text: "saw more scalp coverage after 6 months on Nutrafol Women's Vegan.<sup>14</sup>",
      },
      {
        number: "90%",
        text: "saw overall improvement in their hair after 6 months on Nutrafol Women.<sup>2</sup>",
      },
      {
        number: "100%",
        text: "showed improvement in hair growth after 9 months on Nutrafol Women’s Balance.<sup>4</sup>",
      },
      {
        number: "84%",
        text: " showed improvement in their hair on Nutrafol Men.<sup>2</sup>",
      },
    ],
  },
  questions: [
    {
      title: "Is Nutrafol suitable for everyone?",
      answer: `Not only is Nutrafol suitable for most people, but our hair growth supplements are specifically formulated to meet you where you are in life. We have 4 Nutraceutical formulas that are tailored to the bio-specific needs of men and women throughout all life stages: Women's, Postpartum for the first year after childbirth or while breastfeeding, Women's Balance for peri- and postmenopause, and Men's.<br/><br/>Please note: We do not recommend Nutrafol to anyone under the age of 18. Also, while we have no reason to believe it's harmful, there have not been enough studies for us to say Nutrafol is suitable during pregnancy—so we recommend skipping it while pregnant or trying to conceive and sticking with Nutrafol Postpartum while breastfeeding. If you have a medical condition, or are taking medications (especially anticoagulant and blood-thinning drugs), please consult with your physician before taking Nutrafol.`,
    },
    {
      title: "Will Nutrafol work for my hair type?",
      answer: `Nutrafol products were formulated to promote hair growth and hair wellness for all types of hair. While the characteristics of hair strands may vary by ethnicity, the underlying root causes that affect hair follicles can affect all people equally.<br/><br/>In a recent clinical study, we examined the effectiveness of Nutrafol in African American, Asian, Hispanic, and non-Hispanic men and women. All ethnicities saw less shedding after 2 months and improved thickness, growth rate, scalp coverage, and shine after 6 months of taking our Hair Growth Nutraceuticals.`,
    },
    {
      title: "How do Nutrafol hair growth Nutraceuticals work?",
      answer: `Cutting-edge hair science tells us that genetics isn't the only factor at play when it comes to thinning hair; there are multiple imbalances in the body that can lead to compromised hair health. That's why our clinically proven Hair Growth Nutraceuticals are formulated to target multiple root causes—including stress, hormones, aging, metabolism, nutrition, and lifestyle—all with natural ingredients that support whole-body health from within.`,
    },
    {
      title: "When can I expect to see results?",
      answer: `Everyone's experience is different, but in our clinical studies, women showed results in 3-6 months. It's important to remember that healthy hair growth takes time—and of course, consistency is key. If you take Nutrafol daily, here's a snapshot of what you're likely to experience:<br/><br/>
          &bull; 1-3 Months: Strengthen hair from within. Look for shinier hair with less shedding and breakage.<br/>
          &bull; 3-6 Months: You may notice improvement in fullness and volume.<br/>
          &bull; 6+ Months: Experience visible changes like faster-growing hair that’s thicker and stronger.<br/><br/>
          Commitment to Nutrafol has whole-body rewards, too. Our ingredients are shown to promote better sleep, less stress, and clearer skin. A little something we call side benefits.<br/>
          <i>*Results may vary.</i>
        `,
    },
  ],
}
